/**
 * @license alexgorbatchev/node-crc v3.8.0
 * Copyright(c) 2014 Alex Gorbatchev
 * License: https://github.com/alexgorbatchev/node-crc/blob/master/LICENSE
 * Full source: https://github.com/alexgorbatchev/node-crc/blob/v3.8.0/create_buffer.js
 */

import { Buffer } from 'buffer';
var createBuffer = Buffer.from && Buffer.alloc && Buffer.allocUnsafe && Buffer.allocUnsafeSlow ? Buffer.from :
// support for Node < 5.10
function (val) {
  return new Buffer(val);
};
export default createBuffer;